setTimeout(function () {
    const checkUser = document.querySelectorAll('.checklimit');
    if (checkUser) {
        const checkForm = document.querySelector('.cart-recap');
        if (checkForm) {
            checkForm.addEventListener('submit', function (event) {
                const errorCard = document.querySelector('.validation-wrap');
                const totalPrice = document.querySelector('.cart-recap__scroller .cart-recap__price-line-price').textContent.replace("$", "").replace(",", "");
                const limit = 20;
                if (totalPrice > limit) {
                    errorCard.classList.remove('show-error');
                } else {
                    event.preventDefault();
                    errorCard.classList.add('show-error');
                }
            })
        }
        
    }
}, 500);


(function () {
    const openQuoteFormButton = document.querySelector('[data-open-quote-form-btn]');
    const cancelQuoteFormButton = document.querySelector('[data-button-cancel-quote]');
    const quoteForm = document.querySelector('#quote-form');
    const recipientInput = document.querySelector('#quote-recipient');
    // Prevent form submission on enter
    if (recipientInput) {
        recipientInput.addEventListener('keydown', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });
    }
    
    if (openQuoteFormButton) {
        openQuoteFormButton.addEventListener('click', function (e) {
            e.preventDefault();
            quoteForm.style.display = 'block';
            openQuoteFormButton.style.display = 'none';
        });
    }
    
    if (cancelQuoteFormButton) {
        cancelQuoteFormButton.addEventListener('click', function (e) {
            e.preventDefault();
            quoteForm.style.display = 'none';
            openQuoteFormButton.style.display = 'flex';
        });
    }
    

    if (quoteForm) {
        const sendBtn = document.querySelector('[data-button-send-quote]');
        sendBtn.addEventListener('click', function (e) {
            e.preventDefault();

            if (sendBtn.classList.contains('button--disabled')) {
                return;
            }

            // Change state of button
            sendBtn.classList.add('button--disabled');
            sendBtn.textContent = 'Sending...';

            // Prepare data
            const noteEl = document.querySelector('#note');
            const data = {
                debtorid: MYOB_CUSTOMER_ID,
                customer_id: SHOPIFY_CUSTOMER_ID,
                hmac: SEND_CART_HMAC,
                email: document.querySelector('#quote-recipient').value.trim(),
                notes: noteEl ? noteEl.value : ''
            };

            const lineItems = [];
            const tableRows = document.querySelectorAll('table.line-item-table tbody tr.line-item');
            tableRows.forEach(function (row) {
                lineItems.push({
                    id: row.dataset.id,
                    sku: row.dataset.sku,
                    quantity: parseInt(row.dataset.qty),
                    originalPrice: row.dataset.originalPrice,
                    title: row.dataset.title
                });
            });
            data.line_items = lineItems;

            fetch('/a/cws/send-quote', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json())
                .then(res => {
                    if (res.success) {
                        alert('Success! The quote has been generated and sent to the email address you provided.');
                        quoteForm.style.display = 'none';
                        openQuoteFormButton.style.display = 'flex';
                    } else {
                        alert(res.msg);
                    }
                })
                .catch(console.error)
                .finally(() => {
                    sendBtn.classList.remove('button--disabled');
                    sendBtn.textContent = 'Send';
                })
        });
    }
})();